<template>
  <span>
    <img
      v-if="cardType.toUpperCase() == 'VISA'"
      class="cardType"
      :style="{ height: height }"
      src="@/assets/img/visa.svg"
    />
    <img
      class="cardType"
      v-if="cardType.toUpperCase() == 'AMERICAN_EXPRESS'"
      :style="{ height: height }"
      src="@/assets/img/amex.svg"
    />
    <img
      class="cardType"
      v-if="cardType.toUpperCase() == 'DINERS_CLUB'"
      :style="{ height: height }"
      src="@/assets/img/diners.svg"
    />
    <img
      class="cardType"
      v-if="cardType.toUpperCase() == 'JCB'"
      :style="{ height: height }"
      src="@/assets/img/jcb.svg"
    />
    <img
      class="cardType"
      v-if="cardType.toUpperCase() == 'MASTERCARD'"
      :style="{ height: height }"
      src="@/assets/img/mastercard.svg"
    />
    <img
      class="cardType"
      v-if="cardType.toUpperCase() == 'DISCOVER'"
      :style="{ height: height }"
      src="@/assets/img/discover.svg"
    />
  </span>
</template>

<script>
export default {
  name: "card-svg-large",
  props: {
    cardType: null,
    height: {
      default: "30px",
    },
  },
};
</script>

<style></style>
